module.exports = __webpack_public_path__ + "img/block_gray.3bc7aa83.png";